import { createApp } from 'vue';
import axios from 'axios';
import {getUsersGeoPosition, getUsersGeoPositionFromStorage, calcDistance, sortRetailerList} from './shared/geolocation.js';
import IntlTelInput from "intl-tel-input/vueWithUtils";
import "intl-tel-input/styles";
import { no } from "intl-tel-input/i18n";

export default {
    name: 'orderForm',

    _container: null,
    _retailers: null,
    init() {
        this._container = document.getElementById('js_orderForm');

        if (this._container) {
            this.run();
        }
    },
    run ()
    {
        const siteId = JSON.parse(this._container.getAttribute('data-siteid'));

        let regNumber = '';
        let chassisNo = '';
        let firstName = '';
        let lastName = '';
        let email = '';
        let phone = null;
        let message = '';
        let mileage = '';
        let street = '';
        let zipcode = '';
        let city = '';
        let testMode = false;

        const queryString = window.location.search;
        if (queryString.search('test=orderForm') !== -1) {
            testMode = true;
            firstName = 'Ola';
            lastName = 'Nordmann';
            // email = 'email.'+ Math.floor(Math.random() * 9999)+ '@example.com';
            email = 'test@example.com';
            phone = '91234567';
            message = 'Test :-)';
            regNumber = 'UR88165';
            mileage = '123456';
            street = 'Kanonveien 9';
            zipcode = '0001';
            city = 'Oslo';
        }

        createApp({
            delimiters: ['@{', '}'],
            data() {
                return {
                    a : 'orderForm',
                    attachment : null,
                    attachmentClass : '',
                    brandName : '',
                    chassisNo : chassisNo,
                    city : city,
                    countryCode : 'no',
                    currentRetailer : null,
                    email : '',
                    firstName : firstName,
                    geoActive: false,
                    hasRegNumber : '1',
                    validation : false,
                    lastName : lastName,
                    item : null,
                    gdpr : false,
                    lat : null,
                    lng : null,
                    message : message,
                    mileage : mileage,
                    modelName : '',
                    newsletter : false,
                    order : 'asc',
                    phoneOptions : {
                        separateDialCode: false,
                        initialCountry: 'no',
                        preferredCountries: 'no',
                        countrySearch: false,
                        onlyCountries: ['no', 'se'],
                        i18n: no,
                    },
                    phone : phone,
                    publicItems : [],
                    regNumber : regNumber,
                    responseStatus : '',
                    responseMessage : '',
                    retailerId : '',
                    retailerList : [],
                    siteId : siteId,
                    street : street,
                    step : 1,
                    sortBy: 'name',
                    subject : 'Verkstedskjema ',
                    services : [],
                    testMode : testMode,
                    type : 'service',
                    userId : email,
                    yearModel : '',
                    zipcode : zipcode
                }
            },
            created()
            {
                this.host           = document.querySelector('[name="site_root"]').content;
                this.redirect       = window.location.href;
                // set sort by distance if geo position already stored
                this.sortRetailersByDistance();
                // get retailers from endpoint
                this.getRetailers();
                document.getElementById('js_orderForm').classList.add('is-ready');
            },

            components: {
                IntlTelInput
            },

            computed:
                {
                    validStep()
                    {
                        const validation = this.validation;
                        const query = `.order-form__step--${this.step} .required-field`;
                        const fields = document.querySelectorAll(query);

                        let isValid = true;

                        fields.forEach((field) => {
                            let fieldName = field.name;
                            if (this[fieldName] !== null && this[fieldName].length === 0 || this[fieldName] === false) {
                                isValid = false;
                            }
                        });

                        // check if vehicle object (data from vegvesen) is loaded
                        if (this.hasRegNumber === '1' && this.item === null) {
                            isValid = false;
                        }

                        // check if attachment < 5 MB
                        // if (this.step === 2 && this.attachment !== null) {
                        //     isValid = (this.attachmentClass === '') ? true : false;
                        // }

                        return isValid;
                    },

                    sortedRetailers()
                    {
                        let results = sortRetailerList(this.retailerList, this.sortBy, this.order, this.lat, this.lng);
                        // exclude retailers without email
                        results = results.filter((r) => typeof r.email === 'string' && r.email.length > 0);
                        // set default retailer after sorting
                        this.setFirstRetailerItemAsDefault();

                        return results;
                    },

                    responseStatusClass()
                    {
                        if (this.responseStatus === 'ok') {
                            return 'alert--success';
                        } else if (this.responseStatus === 'info') {
                            return 'alert--info';
                        } else if (this.responseStatus === 'error') {
                            return 'alert--error';
                        } else {
                            return '';
                        }
                    }

                },

            methods:
                {
                    getRetailers()
                    {
                        axios.get('/actions/gs/retailer/index')
                            .then(this.getRetailers__callback)
                            .catch(this.axios__error);
                    },

                    getRetailers__callback(response)
                    {
                        if (typeof response.data === 'object') {
                            this.retailerList = response.data;

                            // check site id to set currentRetailer
                            // if (Number.isInteger(this.siteId) && this.siteId > 1) {
                            //     for(let i=0; i<this.retailerList.length; i++) {
                            //         if (this.retailerList[i].site_id == this.siteId) {
                            //             this.setCurrentRetailer(this.retailerList[i]);
                            //             break;
                            //         }
                            //     }
                            // }
                        }
                    },

                    getRegNumber()
                    {
                        this.regNumber = this.regNumber.length > 0 ?  this.regNumber.replaceAll(' ', '') : '';

                        return this.regNumber;
                    },

                    getCityByZipcode()
                    {
                        if (! this.zipcode || ! this.countryCode) {
                            // console.info('missing zipcode/countryCode');
                            return false;
                        }

                        const queryArgs = {
                            country_code : this.countryCode,
                            zipcode : this.zipcode,
                        }

                        this.rest('/actions/mm/location/index', queryArgs, 'getCityByZipcode__callback');
                    },

                    getCityByZipcode__callback(response)
                    {
                        const attr = 'place name';
                        if (typeof response === 'object' && typeof response.data === 'object' && typeof response.data.places[0][attr] !== 'undefined') {
                            this.city = response.data.places[0][attr];
                        }
                    },

                    hasRegNumberChanged()
                    {
                        setTimeout(() => this.validation = ! this.validation, 200);
                    },

                    isDevEnv()
                    {
                        return (document.location.host === "gspartner.test") ? true : false;
                    },

                    isGsBrand()
                    {
                        const itemBrandName = (this.item && typeof this.item === 'object' && this.item.merkenavn) ? this.item.merkenavn : '';
                        // const textBrandName = this.brandName;
                        // let checkBrandName = itemBrandName.length ? itemBrandName : textBrandName;
                        let checkBrandName = itemBrandName;

                        return ['bmw', 'mini'].some(element => checkBrandName.toLowerCase().includes(element));
                    },

                    isActiveTab(stepId)
                    {
                        let cssClass = (stepId == this.step) ? 'active' : '';
                        cssClass += (stepId < this.step) ? ' passed ' : '';

                        return cssClass;
                    },

                    logRetailer(retailer, referer)
                    {
                        if (this.isDevEnv()) {
                            console.log(referer+': '+ retailer.id + ' '+retailer.name + ' '+retailer.shortname+ ' '+retailer.skyspanner);
                        }
                    },

                    maybeRedirectToSkyspanner()
                    {
                        const canSkyspanner = (this.currentRetailer.shortname.length && this.currentRetailer.skyspanner == '1');

                        const isGsBrand = this.isGsBrand();

                        const doRedirect = (canSkyspanner && isGsBrand && this.getRegNumber());

                        if (this.isDevEnv()) {
                            console.log(`do redirect: ${doRedirect}`);
                        }

                        const redirect = (doRedirect) ?
                            `https://service.gsbildeler.no/?verksted=${this.currentRetailer.shortname}&reg_number=${this.getRegNumber()}` : null;

                        // console.log(redirect);
                        return redirect;
                    },

                    nextStep()
                    {
                        this.step += 1;

                        const redirect = this.maybeRedirectToSkyspanner();

                        if (redirect) {
                            window.location.href = redirect;
                        } else {
                            this.scrollToForm();
                        }
                    },

                    prevStep()
                    {
                        this.step -= 1;
                        this.scrollToForm();
                    },

                    retailerChanged()
                    {
                        // find retailer object by id
                        const newRetailer = this.retailerList.filter((item) => item.id == this.retailerId);

                        if (typeof newRetailer === 'object' && newRetailer.length===1) {
                            this.setCurrentRetailer(newRetailer[0]);
                        }
                    },

                    setCurrentRetailer(retailer)
                    {
                        this.logRetailer(retailer, 'setCurrentRetailer');
                        this.currentRetailer = retailer;
                        this.retailerId = this.retailerId == retailer.id ? this.retailerId : retailer.id;
                    },

                    setFirstRetailerItemAsDefault()
                    {
                        if (this.currentRetailer === null && typeof this.retailerList[0] === 'object') {
                            this.setCurrentRetailer(this.retailerList[0]);
                        }
                    },

                    scrollToForm()
                    {
                        const el = document.getElementById('js_orderForm');
                        // el.style.top = (el.offsetTop-100) +"px";
                        el.scrollIntoView({block: "start", behavior: "smooth"});
                    },

                    showClosestRetailer()
                    {
                        this.geoActive = true;
                        getUsersGeoPosition();
                        setTimeout(this.showClosestRetailer__callback, 1000);
                    },

                    showClosestRetailer__callback()
                    {
                       this.sortRetailersByDistance();
                    },

                    sortRetailersByDistance()
                    {
                        const position = getUsersGeoPositionFromStorage();

                        if (position) {
                            // console.log('sortRetailersByDistance');
                            // console.log(position);
                            this.lng = position.lng;
                            this.lat = position.lat;
                            this.sortBy = 'distance';
                            this.order = 'asc';
                        }

                        this.geoActive = false;
                    },



                    validateAttachment()
                    {
                        this.attachment = this.$refs.attachment;
                        // console.log(this.attachment);
                        const file = (this.attachment && typeof this.attachment.files !== 'undefined') ?
                            this.$refs.attachment.files[0] :
                            null;

                        const limit = 1024 * 1024 * 5; // 5 MB
                        this.attachmentClass = (file && file.size > limit) ?
                            'error' :
                            '';
                    },

                    onSubmit(event)
                    {
                        const headers = { "Content-Type": "multipart/form-data" };
                        const postData = this.prepareData();
                        const url = '/actions/mm/mail/store';

                        this.responseStatus = 'info';
                        this.responseMessage = 'Sender forespørsel';

                        axios.post(url, postData, headers)
                            .then(this.onSubmit__callback)
                            .catch(this.axios__error);
                    },

                    prepareData()
                    {
                        const token = document.querySelector('[name="CRAFT_CSRF_TOKEN"]');

                        const bodyFormData = new FormData();

                        let brandName = this.brandName;
                        let modelName = this.modelName;
                        let yearModel = this.yearModel;
                        if (this.hasRegNumber === '1') {
                            brandName = this.item?.merkenavn;
                            modelName = this.item?.modell;
                            yearModel = this.item?.reg_aar;
                        }

                        bodyFormData.append('brand_name', brandName);
                        bodyFormData.append('chassis_no', this.chassisNo);
                        bodyFormData.append('city', this.city);
                        bodyFormData.append('country', this.countryCode);
                        bodyFormData.append('email', this.userId);
                        bodyFormData.append('first_name', this.firstName);
                        bodyFormData.append('gdpr', this.gdpr);
                        bodyFormData.append('honeypot', document.getElementById('email').value);
                        bodyFormData.append('last_name', this.lastName);
                        bodyFormData.append('message', this.message);
                        bodyFormData.append('model', modelName);
                        bodyFormData.append('mobile', this.phone.replaceAll(' ', ''));
                        // bodyFormData.append('newsletter', this.newsletter);
                        bodyFormData.append('retailerId', this.retailerId);
                        bodyFormData.append('redirect', this.redirect);
                        bodyFormData.append('reg_number', this.regNumber);
                        bodyFormData.append('mileage', this.mileage);
                        bodyFormData.append('type', this.type);
                        // bodyFormData.append('services', this.services.join(','));
                        bodyFormData.append('street', this.street);
                        bodyFormData.append('subject', this.subject);
                        bodyFormData.append('zipcode', this.zipcode);
                        bodyFormData.append('year_model', yearModel);

                        // if (typeof this.attachment !== 'undefined' && this.attachment !== null && this.attachment.files.length === 1) {
                        //     bodyFormData.append('attachment', this.attachment.files[0]);
                        // }
                        return bodyFormData;
                    },

                    onSubmit__callback(response)
                    {
                        console.log('onSubmit__callback');
                        console.log(response);
                        if (typeof response === 'object' && typeof response.data === 'object') {
                            this.responseMessage = response.data.message;
                            this.responseStatus = 'ok';
                        }
                    },

                    findRegNumber()
                    {
                        const endpoint = '/actions/mm/regnr/get-vehicle';
                        const queryArgs = { reg_number : this.getRegNumber() };
                        this.rest(endpoint, queryArgs, 'findRegNumber__callback');
                    },

                    findRegNumber__callback(response)
                    {
                        if (response.data.item && typeof response.data.item === 'object') {
                            this.item = response.data.item;
                            this.chassisNo = response.data.item.chassis_no;
                        } else {
                            this.responseStatus = 'error';
                            this.responseMessage = 'Registreringsnummeret ble ikke funnet';
                        }
                    },

                    rest(endpoint, queryArgs, callback)
                    {
                        this.responseStatus = this.responseMessage = '';

                        let queryString = "";
                        for (var i in queryArgs) {
                            queryString += i + "=" + queryArgs[i]+"&";
                        }
                        const url =  endpoint + "?" + queryString;

                        axios.get(url)
                            .then(this[callback])
                            .catch(function (error) {});
                    },

                    axios__error(error)
                    {
                        console.log('axios__error');
                        console.log(error);
                        this.responseStatus = 'error';
                        this.responseMessage = error;
                    }
                }
        }).mount(this._container); // end of vue

    }
}